module.exports = __webpack_public_path__ + "static/media/leather.97b6220d.jpg";